import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSettings } from '../context/SettingsContext';

/**
 * Full-screen branded loading splash shown on first app load.
 * Fades out once settings are ready (min ~1.6s so it never flickers).
 */
export default function Splash() {
  const { settings } = useSettings();
  const [show, setShow] = useState(true);
  const [minDone, setMinDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMinDone(true), 1600);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (minDone && settings) setShow(false);
  }, [minDone, settings]);

  const logo = settings?.logo || '/logo.png';

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="splash__glow" />
          <motion.div
            className="splash__logo"
            initial={{ scale: 0.8, opacity: 0, y: 10 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <img src={logo} alt={settings?.siteName || 'Kortex'} />
          </motion.div>

          <motion.div
            className="splash__name"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25, duration: 0.5 }}
          >
            {settings?.siteName || 'Kortex'}
          </motion.div>

          <div className="splash__bar"><span /></div>
          <motion.p
            className="splash__tag"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            {settings?.tagline || 'Loading…'}
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
